export class AddGroupItem {
  constructor(groupName) {
    this.groupName = groupName;
  }
}
